module.exports = __webpack_public_path__ + "static/media/btc.43fe9dfa.png";